import React from "react";
import { Nav, Loader } from "ui-kit-ck-consultant";
import FadeIn from "react-fade-in";
import moment from "moment";

import ShowOptions from "../../../components/statistics/statistics-selfcare/ShowOptions";
import CardALLIANZPJ from "../../../components/statistics/statistics-allianzPJ/CardALLIANZPJ";

import AuthContext from "../../../context/AuthContext";

import axiosConfig from "../../../utils/axiosConfig";

export default class StatisticsAllianzPJ extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: false,
      dateStart: moment().format("YYYY-01-01"),
      dateEnd: moment().format("YYYY-MM-DD"),
      network: "1",
      group: "1",
      region: 0,
      agency: 0,
      data: null,
    };
  }

  static contextType = AuthContext;

  getData = () => {
    this.setState(
      {
        isLoad: true,
      },
      () => {
        axiosConfig({
          url: "pilotage-cabinet/company-performance/statistics-allianzPJ",
          data: {
            year: Number(moment(this.state.dateEnd).format("YYYY")),
            region: this.state.region,
            agency: this.state.agency,
          },
          timeout: 240000,
        })
          .then((res) => {
            if (res.data.success) {
              this.setState({ data: res.data.data, isLoad: false });
            } else {
              this.setState({ data: null, isLoad: false }, () =>
                alert("Erreur")
              );
            }
          })
          .catch(() => {
            this.setState({ data: null, isLoad: false }, () => alert("Erreur"));
          });
      }
    );
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;

    let dateStart = this.state.dateStart;
    let dateEnd = this.state.dateEnd;

    if (
      name === "dateEnd" &&
      moment(value).format("YYYY") !== moment(dateStart).format("YYYY")
    ) {
      dateStart = moment(`${moment(value).format("YYYY")}-01-01`).format(
        "YYYY-MM-DD"
      );
    } else if (
      name === "dateStart" &&
      moment(value).format("YYYY") !== moment(dateEnd).format("YYYY")
    ) {
      dateEnd = moment(`${moment(value).format("YYYY")}-12-31`).format(
        "YYYY-MM-DD"
      );
    }

    this.setState({
      dateStart,
      dateEnd,
      [name]: value,
    });
  };

  handleSelectChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: Number(value) }, () => {
      if (name === "network") {
        this.setState({ group: 0, region: 0, agency: 0 });
      } else if (name === "group") {
        this.setState({ region: 0, agency: 0 });
      } else if (name === "region") {
        this.setState({ agency: 0 });
      }
    });
  };

  render() {
    return (
      <>
        <FadeIn>
          <Nav title="Statistiques PJ-RC-PM" className="mb-20" />
          <ShowOptions
            className="mb-20"
            handleInputChange={this.handleInputChange}
            handleSelectChange={this.handleSelectChange}
            getData={this.getData}
            isDateStart={true}
            isDateEnd={true}
            dateStart={this.state.dateStart}
            dateEnd={this.state.dateEnd}
            network={this.state.network}
            group={this.state.group}
            region={this.state.region}
            agency={this.state.agency}
          />
          {this.state.data ? <CardALLIANZPJ data={this.state.data} /> : null}
          <Loader show={this.state.isLoad} />
        </FadeIn>
      </>
    );
  }
}
